/** @format */

import { defaultsDeep } from '@power/utils';
const defaultSetting = {
	isParent: 'isParent',
	childrenKey: 'children',
	nameKey: 'name',
	titleKey: 'title',
	idKey: 'id',
	pIdKey: 'parentId',
	levelKey: 'level',
	rootPId: null,
};

const TreeUtils = {
	/**
	 * 转换成树形结构
	 * @param {*} data 数据
	 * @param {*} setting 设置
	 */
	transformToTreeFormat(data, setting = {}) {
		const sNodes = JSON.parse(JSON.stringify(data));
		setting = defaultsDeep({}, setting, defaultSetting);
		const idKey = setting.idKey;
		const pIdKey = setting.pIdKey;
		const childrenKey = setting.childrenKey;

		let i, j, l;
		if (!idKey || idKey === '' || !sNodes) {
			return [];
		}
		if (sNodes instanceof Array) {
			const r = [];
			const tmpMap = [];
			for (i = 0, l = sNodes.length; i < l; i++) {
				tmpMap[sNodes[i][idKey]] = sNodes[i];
			}

			for (j = 0, l = sNodes.length; j < l; j++) {
				// 判断是否是叶子节点
				if (sNodes[j][childrenKey]) {
					if (setting.isLeaf) {
						sNodes[j]['disabled'] = true;
					}
				}
				if (tmpMap[sNodes[j][pIdKey]] && sNodes[j][idKey] !== sNodes[j][pIdKey]) {
					if (!tmpMap[sNodes[j][pIdKey]][childrenKey]) {
						tmpMap[sNodes[j][pIdKey]][childrenKey] = [];
					}
					tmpMap[sNodes[j][pIdKey]][childrenKey].push(sNodes[j]);
				} else {
					r.push(sNodes[j]);
				}
			}
			return r;
		} else {
			return [sNodes];
		}
	},
};

export { TreeUtils };
